export default __webpack_public_path__ + "static/media/pol-academy.d99b30e5.png";